/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import {useAppSelector} from "../../../redux/hooks";
import {selectGlobalRightClickMenuState} from "../../../redux/ducks/GlobalRightClickMenu/slice";
import LaunchIcon from '@mui/icons-material/Launch';
import styled from "styled-components";
import * as colors from '../../../constants/colors'
import ArgosFlexbox from "../Containers/ArgosFlexbox";

const Div = styled.div({
  borderRadius: 4,
  backgroundColor: colors.lightGray,
  ':hover': {
    backgroundColor: colors.darkGray
  },
})

interface IArgosLaunchIconProps {
  onClick: React.MouseEventHandler<SVGSVGElement>
}

export const ArgosLaunchIcon = (props: IArgosLaunchIconProps) => {
  return (
    <ArgosFlexbox alignItems={'center'}>
      <Div style={{}}>
        <LaunchIcon cursor={'pointer'} onClick={props.onClick}/>
      </Div>
    </ArgosFlexbox>
  )
}
const GlobalRightClickMenu = () => {
  const pos = useAppSelector(selectGlobalRightClickMenuState).pos
  const data = useAppSelector(selectGlobalRightClickMenuState).data
  const isVisible = pos != null

  const onClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    window.open(data.url, '_blank')
  }
  return (
    <>
      {(isVisible && data) &&
        <div style={{position: 'absolute', zIndex: 99999, left: pos.x + 15, top: pos.y - 35}}>
          {/*<div style={{backgroundColor: 'white', borderRadius: 4}}>*/}
          <ArgosLaunchIcon onClick={onClick}/>
        </div>
      }
    </>
  )
}

export default GlobalRightClickMenu